import { PopupPlotActionType, type PopupPlotsActions, type SetPopupPlotState } from "@/reducer/plot/action";
import type { PopupPlotState } from "@/reducer/plot/state";

export function popupPlotsReducer(state: PopupPlotState, action: PopupPlotsActions): PopupPlotState {
  switch (action.type) {
    case PopupPlotActionType.SetPopupPlotState:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export const setPopupPlotState = (state: PopupPlotState): SetPopupPlotState => ({
  type: PopupPlotActionType.SetPopupPlotState,
  payload: state,
});
